import tenant from "@shared/lib/Http"
import { _ } from "core-js"
import { stubString } from "lodash"

const state = {
    formBuilder: {
        form: {
            name: "",
            slug: "",
            description: "",
            active: true,
            embed_code: "",
            background_image: "",
            background_image_url: "",
            show_quote: null,
            custom_intro_text: "",
            credit_check: null,
            intro_text: "",
            form_config: {
                groups: [],
                fields: [],
                isGroupsActive: false
            },
            team_id: null,
        }
    },
    fields: [],
    currentField: {},
    activeSidebarTab: "fields",
    activeFieldType: "basic",
    showSettingsModal: false,
    saving: false,
    errors: [],
    mapComponentList: [
        {
            label: "Qualifying Questionnaire",
            value: "qualifyingQuestionnaire",
        },
        {
            label: "Fast Track",
            value: "fastTrack",
        },
        {
            label: "App Pack",
            value: "appPack",
        },
    ],
    columns: [
        {
            label: "One Column",
            value: 1
        },
        {
            label: "Two Columns",
            value: 2
        },
        {
            label: "Three Columns",
            value: 3
        },
    ],
    blockColumns: [
        {
            label: "One Column",
            value: 1
        },
        {
            label: "Two Columns",
            value: 2
        },
        {
            label: "Three Columns",
            value: 3
        },
        {
            label: "Four Columns",
            value: 4
        },
        {
            label: "Five Columns",
            value: 5
        },
        {
            label: "Six Columns",
            value: 6
        },
    ],
    types: [
        { label: "Value", value: "input" },
        { label: "Selection", value: "select" },
        { label: "Field", value: "field" },
    ],
    operators: [
        { label: "Equals", value: "==" },
        { label: "Not Equal", value: "!=" },
        { label: "Not Empty", value: "notEmpty" },
        { label: "Less Than", value: "<" },
        { label: "More Than", value: ">" },
        { label: "Less Than or Equal To", value: "<=" },
        { label: "More Than or Equal To", value: ">=" },
    ],
    formDragOptions: {
        group: { name: "formbuilder", pull: true, put: true },
        sort: true,
        ghostClass: "form-ghost",
        handle: ".move-field",
    },
    sidebarDragOptions: {
        group: { name: "formbuilder", pull: "clone", put: false },
        sort: false,
    },
    options: []
}

const getters = {
    formBuilder: state => state.formBuilder,
    form: state => state.formBuilder.form,
    formFields: state => _.get(state.formBuilder.form.form_config, 'fields', []),
    fields: state => state.fields,
    columns: state => state.columns,
    blockColumns: state => state.blockColumns,
    types: state => state.types,
    operators: state => state.operators,
    currentField: state => state.currentField,
    formSettings: state => {
        return {
            name: state.formBuilder.form.name,
            slug: state.formBuilder.form.name,
            description: state.formBuilder.form.description,
            active: state.formBuilder.form.active,
            embed_code: state.formBuilder.form.embed_code,
            background_image: state.formBuilder.form.background_image,
            background_image_url: state.formBuilder.form.background_image_url,
            team_id: state.formBuilder.form.team_id
        }
    },
    config: state => state.formBuilder.form.form_config,
    groupSettings: state => _.get(state.formBuilder.form.form_config, 'groups', []),
    activeSidebarTab: state => state.activeSidebarTab,
    activeFieldType: state => state.activeFieldType,
    mapComponentList: state => state.mapComponentList,
    sidebarDragOptions: state => state.sidebarDragOptions,
    formDragOptions: state => state.formDragOptions,
    showSettingsModal: state => state.showSettingsModal,
    saving: state => state.saving,
    errors: state => state.errors,
    options: state => state.options,
}

const mutations = {
    saveForm: (state, form) => {
        state.formBuilder.form = {...state.formBuilder.form, ...form}
    },
    clearForm: (state, form) => {
        state.formBuilder.form.form_config.fields = []
    },
    saveActiveSidebarTab: (state, tab) => {
        state.activeSidebarTab = tab
    },
    saveActiveFieldType: (state, type) => {
        state.activeFieldType = type
    },
    saveFields: (state, fields) => {
        state.fields = fields
    },
    saveCurrentField: (state, field) => {
        state.currentField = field
    },
    showSettingsModal: (state, show) => {
        state.showSettingsModal = show
    },
    saving: (state, saving) => {
        state.saving = saving
    },
    setFormFields: (state, formFields) => {

        const generateSubFields = (field) => {

            field.subFields.forEach(subField => {

                if (subField.type == 'pageColumns') {
                    _.set(subField, 'field_mapping', _.get(field, 'field_mapping', ''))
                }

                // subField.field_mapping = _.get(field, 'field_mapping', '')
                subField.field_mapping_parent = _.get(field, 'field_mapping', '')

                // check to see if the field has subfields
                let hasSubFields = _.has(subField, "subFields", false) && !_.isEmpty(subField.subFields)

                if (hasSubFields) {
                    subField.subFields = generateSubFields(subField)
                }
            })

            return field.subFields
        }

        if (!_.isEmpty(formFields)) {

            formFields.forEach((field, fieldKey) => {

                field.field_mapping_parent = null

                // check to see if the field has subfields
                let hasSubFields = _.has(field, "subFields", false) && !_.isEmpty(field.subFields)

                if (hasSubFields) {
                    field.subFields = generateSubFields(field)
                }
            })
        }

        state.formBuilder.form.form_config.fields = formFields
    },
    saveOptions: (state, options) => {
        state.options = options
    },
    setErrors: (state, errors) => {
        state.errors = errors
    },
}

const actions = {
    clearForm: ({ commit }, form) => {
        commit("clearForm", form)
    },
    saveForm: ({ commit }, form) => {
        commit("saveForm", form)
    },
    saveActiveSidebarTab: ({ commit }, tab) => {
        commit("saveActiveSidebarTab", tab)
    },
    saveActiveFieldType: ({ commit }, type) => {
        commit("saveActiveFieldType", type)
    },
    saveFields: ({ commit }, fields) => {
        commit("saveFields", fields)
    },
    saveCurrentField: ({ commit, dispatch }, field) => {
        commit("saveCurrentField", field)
        if (_.isEmpty(field)) {
            dispatch("saveActiveSidebarTab", 'fields')
        } else {
            dispatch("saveActiveSidebarTab", 'field')
        }
    },
    showSettingsModal: ({ commit }, show) => {
        commit("showSettingsModal", show)
    },
    saving: ({ commit }, saving) => {
        commit("saving", saving)
    },
    save: ({ commit, state, dispatch }, data) => {
        return new Promise((resolve, reject) => {

            state.errors = []
            dispatch("saving", true)

            let formData = new FormData()
            let form = Object.entries(state.formBuilder.form).reduce((a, [k, v]) => (v ? ((a[k] = v), a) : a), {})
            
            if (!data.canDoCreditCheck) {
                _.set(form, 'credit_check', '0')
            }

            let backgroundImage = form.background_image
            delete form["background_image"]
            Object.entries(form).forEach((formSetting) => {
                formData.append(formSetting[0], formSetting[1])
            })
            if (backgroundImage) {
                formData.append("background_image", backgroundImage)
            }

            formData.append("formData", JSON.stringify(form))

            formData.append("team_id", JSON.stringify(Ambition.currentTeamId()))

            formData.append(
                "form_config",
                JSON.stringify({
                    groups: _.get(form.form_config, "groups", []),
                    fields: _.get(form.form_config, "fields", [])
                })
            )

            tenant.post(`/api/forms/save-form/${form.id}`, formData).then(res => {
                dispatch("saving", false)
                if (_.has(res, "data.errors", false)) {
                    state.errors = res.data.errors
                } else {
                    commit('saveForm', res.data.form)
                    dispatch('showSettingsModal', false)
                }
                resolve(res)
            }).catch(error => {
                reject(error)
            }).finally(() => {
                dispatch("saving", false)
            })
        })
    },

    setFormFields: ({ commit }, formFields) => {
        commit("setFormFields", formFields)
    },

    saveOptions: ({ commit }, options) => {
        commit("saveOptions", options)
    },

    setErrors: ({ commit }, errors) => {
        commit("setErrors", errors)
    },
}

export default {
    formBuilder: {
        namespaced: true,
        state,
        getters,
        actions,
        mutations
    }
}
